// extracted by mini-css-extract-plugin
module.exports = {"root":"bj_bJ"};